<template>
  <v-select
    v-if="selectLists"
    v-bind="$attrs"
    v-model="input"
    :items="selectLists.TaskPriorities"
    item-text="Text"
    item-value="Value"
    :label="label"
    dense
  >
    <template v-slot:item="{ item }">
      <v-icon small :color="item.Color">{{ item.Icon }}</v-icon>
      <div class="ml-1">{{ item.Text }}</div>
    </template>
    <template v-slot:selection="{ item }">
      <v-icon small :color="item.Color">{{ item.Icon }}</v-icon>
      <div class="ml-1">
        {{ item.Text }}
      </div>
    </template>
  </v-select>
</template>

<script>
import { ref, watch } from 'vue'
import { selectListCache } from '@/services/SelectListCache'
export default {
  name: 'TaskPriorityPicker',
  props: {
    value: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: 'Priority'
    }
  },
  setup(props, context) {
    const input = ref()
    const selectLists = ref()

    watch(
      () => props.value,
      newVal => {
        input.value = newVal
      }
    )

    watch(
      () => input.value,
      newVal => {
        context.emit('input', newVal)
        context.emit('change', newVal)
      }
    )

    const initControl = async () => {
      await loadSelectLists()
      input.value = props.value
    }

    const loadSelectLists = async () => {
      const selectListNames = [selectListCache.name.TaskPriorities]

      selectLists.value = await selectListCache.get(selectListNames)
    }

    initControl()
    return { input, selectLists }
  }
}
</script>

<style lang="scss" scoped></style>
